import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import FillFromPreviousButton from './fillFromPreviousButton';
const AddFromPreviousButton = props => /*#__PURE__*/React.createElement(FillFromPreviousButton, _extends({}, props, {
  addToCollection: true
}));
export default AddFromPreviousButton;